import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spinner-modal-sqp',
  templateUrl: './spinner-modal-sqp.component.html',
  styleUrls: ['./spinner-modal-sqp.component.css']
})
export class SpinnerModalSqpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
